export const navLinks = [
  { label: "首页", to: "/" },
  { label: "讨论区", to: "/topics" },
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
];